var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AtomLink',{class:_vm.css(),attrs:{"route":_vm.url,"type":_vm.AtomLinkTypeEnum.DARK,"open-in-new-tab":true}},[_c('AtomIcon',{class:_vm.css('play'),attrs:{"name":"play"}}),_vm._v(_vm._s(_vm.t("module.inbox.video_message_label"))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }